module.exports = __webpack_public_path__ + "img/google-icon.40a18ce5.png";